<template>
  <div class="animated fadeIn">
    <b-modal 
        title="Confirmation" 
        variant="success"
        header-bg-variant="success"
        content-class="border-success"
        v-model="showModal" 
        ok-only
        @ok="showModal=false" 
        ok-variant="success"
        >
      Quote Updated and Notification has been sent to the User!
    </b-modal>
    <b-row>
      <b-col lg="12">
        <h5 class="mb-4">Generate Manual Quote (order: S3D000{{order.id}})</h5>
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <strong> Manual Cart Items (order: S3D000{{order.id}})</strong>
              <b-button v-if="order && order.generateQuote" class="mx-2 pull-right text-white" @click="generateQuote()" type="button" size="sm" variant="warning"><i class="fa fa-dot-circle-o"></i> Generate Quote</b-button>
            </div>
            <template v-if="manualcartItems.length">
                <div role="tablist">
                    <b-card no-body class="mb-1" v-for="(cartitem,cartIndex) in manualcartItems" :key="cartitem.id">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-btn block href="#" class="text-left text-white" v-b-toggle="'accordion'+cartitem.id" variant="info" @click="refresh=!refresh;refreshData()">
                                {{cartitem.origName}} (<b>{{cartitem.quantity}}</b>)
                                <span class="pull-right fa fa-trash" style="font-size:18px;" @click="removeCartItem($event,cartitem.id)"></span>
                                <span class="pull-right mr-5" v-if="cartitem.price && cartitem.price.subtotal"> <b>₹ {{cartitem.price.subtotal}}</b></span>
                            </b-btn>
                        </b-card-header>
                        <b-collapse v-bind:id="'accordion'+cartitem.id"  v-bind:visible="!(cartitem.price && cartitem.price.subtotal)" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-col class="p-0">
                                    <b-form inline>
                                        <span class="col-lg-2 text-left text-lg-left text-sm-center col-sm-6 col-12 p-0 mx-auto my-2" v-if="cartitem.process">
                                            Process : <b>{{cartitem.process}}</b>
                                        </span>
                                        <span class="col-lg-2 text-left text-lg-left text-sm-center col-sm-6 col-12 p-0 mx-auto my-2" v-if="cartitem.material">
                                            Material : <b>{{cartitem.material.toUpperCase()}}</b>
                                        </span>
                                        <span class="col-lg-2 text-left text-lg-left text-sm-center col-sm-6 col-12 p-0 mx-auto my-2" v-if="cartitem.color">
                                            Color : <b>{{cartitem.color}}</b>
                                        </span>
                                        <span class="col-lg-2 text-left text-lg-left text-sm-center col-sm-6 col-12 p-0 mx-auto my-2" v-if="cartitem.quality">
                                            Quality : <b>{{cartitem.quality}}</b>
                                        </span>
                                        <span class="col-lg-2 text-left text-lg-left text-sm-center col-sm-6 col-12 p-0 mx-auto my-2" v-if="cartitem.unit">
                                            Unit : <b>{{cartitem.unit}}</b>
                                        </span>
                                        <span class="col-lg-2 text-left text-lg-left text-sm-center col-sm-6 col-12 p-0 mx-auto my-2" v-if="cartitem.quantity">
                                            Quantity : <b>{{cartitem.quantity}}</b>
                                        </span>
                                    </b-form>
                                </b-col>
                                <b-col class="mt-5 px-0">
                                    <b-card no-body class="mb-1">
                                        <b-card-header header-tag="header" class="p-1" role="tab">
                                            <b-btn block href="#" class="text-left" v-b-toggle="'astroprint'+cartitem.id" variant="default">
                                                Astroprint Settings
                                            </b-btn>
                                        </b-card-header>
                                        <b-collapse v-bind:id="'astroprint'+cartitem.id" accordion="astroprint" role="tabpanel">
                                            <b-card-body>
                                                <b-col class="bg-dark py-2">
                                                    <pre class="text-white">{{JSON.stringify(cartitem.astroprint,null,2)}}</pre>
                                                </b-col>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </b-col>
                                <b-col class="mt-5 p-0">
                                    <h6>Pricing Configs</h6>
                                    <b-col class="py-2 px-0">
                                        <!-- Bootstrap Vue has some problems with Inline forms that's why we use some standard bootstrap classes -->
                                        <b-form inline :id="'form'+cartitem.id" :name="'form'+cartitem.id" @submit="updateCartItem($event,cartitem)">
                                            <b-card class="p-0 col-12">
                                                <h6>Properties</h6>
                                                <div class="col-4 p-0 my-3 d-inline" v-for="field in cartitem.pricingfields" :key="field.id">
                                                    <span>{{field.label}}</span> : <b-input v-if="!(cartitem.price && cartitem.price.subtotal) || refresh" class="my-4 mr-4" v-bind:value="(cartitem.changedManualPricingFields && cartitem.changedManualPricingFields[field.varname]) || ''" :name="field.varname" :id="field.label.replace(/ /g,'')" :type="field.type" :placeholder="field.label" required></b-input>
                                                </div>
                                                <template v-if="cartitem.mfprocess.isDirectPrice">
                                                    <h6>Price Calculation</h6>
                                                    <div style="max-width:120px" class="my-2">
                                                        <b-form-checkbox :id="'manualPrice'+(cartitem.id)" :checked="cartitem.manualPrice" @input="updateManualPrice(cartitem, cartIndex)">
                                                            DirectPrice
                                                        </b-form-checkbox>
                                                    </div>
                                                    <template v-if="cartitem.manualPrice">
                                                        <div class="p-0 my-3 d-inline" >
                                                            <span>Manual Price</span> : <b-input :id="'ManualAmount_'+cartitem.id" class="my-1 mr-4 ml-1" type="number" min=1 step="0.01"  placeholder="price" required></b-input>
                                                        </div>  
                                                        
                                                        <template v-if="cartitem.showTax">    
                                                            <div class="p-0 my-3 d-inline" >
                                                                <span>Sgst</span> : <b-input type="number" :id="'sgst_'+cartitem.id" class="my-1 mr-4 ml-1"  min=1 step="0.01"   placeholder="price" required></b-input>
                                                            </div>
                                                            <div class="p-0 my-3 d-inline" >
                                                                <span>Cgst</span> : <b-input type="number"  :id="'cgst_'+cartitem.id" class="my-1 mr-4 ml-1"   min=1 step="0.01"  placeholder="price" required></b-input>
                                                            </div>
                                                        </template>

                                                        <div style="max-width:120px" class="my-2">
                                                            <b-form-checkbox :id="'check'+(cartitem.id)" :checked="cartitem.showTax" @input="updatePriceData(cartitem,cartIndex)">
                                                                inclusive GST?
                                                            </b-form-checkbox>
                                                        </div>
                                                    </template>
                                                </template>
                                                <div slot="footer">
                                                    <span v-if="cartitem.price && cartitem.price.subtotal"> Current Price : <b>₹ {{cartitem.price.subtotal}}</b></span>
                                                    <b-button class="mx-2 pull-right" type="reset" size="sm" variant="danger"><i class="fa fa-ban"></i> Reset</b-button>
                                                    <b-button class="mx-2 pull-right" type="submit" size="sm" variant="primary"><i class="fa fa-dot-circle-o"></i> {{cartitem.manualPrice ? 'Save' : 'Calculate'}}</b-button>
                                                </div>
                                            </b-card>
                                        </b-form>
                                    </b-col>
                                </b-col>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </template>
            <template v-else>
                <div role="tablist" class="text-center">
                    No Manual Cart Items found for this order
                </div>
            </template>
          </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from './utils/ordersTable'

export default {
  name: 'tables',
  components: {cTable},
  async created(){
    this.init()
  },
  data(){
    let permissions = this.$store.getters.canAccess({configkey:'permissions'});
    return {
      permissions,
      showModal:false,
      refresh:false,
      order:{},
      manualcartItems:[],
    }
  },
  methods:{
    updatePriceData:function(cartItem,index){
        cartItem.showTax = document.getElementById('check'+cartItem.id).checked;
        this.$set(this.manualcartItems,index,cartItem);
    },
    updateManualPrice:function(cartItem,index){
        cartItem.manualPrice = document.getElementById('manualPrice'+cartItem.id).checked;
        this.$set(this.manualcartItems,index,cartItem);
    },
    createQuoteAccess: function() { return this.hasAccess('createQuote')},
    editQuoteAccess: function() { return this.hasAccess('updateQuote')},
    getResponseData: function(response) { return (response && response.status=='200' && response.data);},
    generateQuote: async function(){
        let activeUser = false,activeCart= false,activeQuote=false,activeOrder=false,q2Created=false;
        
        // Check if the Order has to be created newly or it is an order only with manual quote
        // if((this.order.status.toLowerCase()=='pending') && (!this.order.subtotal || !this.order.total)){
        //     // CART LOGIC
        //     // Update Cart Total Data if already Exists
        //     activeCart=this.manualcartItems[0].cart.id;
        //     activeUser = this.manualcartItems[0].cart.user;
        //     await this.strapi.axios.put('/carts/update-manual-cart/'+activeCart,{});
        //     // Updated Total Cart Price
        //     activeQuote = this.order.quote.id;
        //     activeOrder = this.order.id;
        // }else{
            // CART LOGIC
            let manualCartItemsProcessed = this.manualcartItems.filter(e=>(!e.cart || e.cart.id==e.manualCart.id)).map(e=>e.id);
            activeUser = this.order.user.id;
            if(manualCartItemsProcessed.length){
                // Create New Cart and update cartitems if cart is empty or manualcart is equal to cart
                let newCart = this.getResponseData(await this.strapi.axios.post('/carts/create-manual-cart',{cartitems:manualCartItemsProcessed}));
                activeCart = newCart.id;
            }else{
                // Update Cart Total Data if already Exists
                activeCart=this.manualcartItems[0].cart.id;
                await this.strapi.axios.put('/carts/update-manual-cart/'+activeCart,{});
            }
            /////////////////////  New Cart Logic done //////////////////////////// 
            if(!(this.order.manualQuote && this.order.manualQuote.id)){
                // New Manual Quote LOGIC
                let QuotePayload = {
                    ...this.order.quote,
                    gateway_properties:{},
                    cart:activeCart,
                };
                // duplicate Existing Quote but remove id to generate new Quote
                delete QuotePayload['id'];
                delete QuotePayload['Order'];
                let newQuote = this.getResponseData(await this.strapi.axios.post('/quotes/',QuotePayload));
                activeQuote = newQuote.id;
                q2Created=true;
                // Update Order telling Q2 is generated
                let updatedOrderManualquote = this.getResponseData(await this.strapi.axios.put('/orders/'+this.order.id,{manualQuote:activeQuote}));
            }else{
                activeQuote = this.order.manualQuote.id;
            }
        // }

        this.generateUrl({userId:activeUser,cartId:activeCart,quoteId:activeQuote,orderId:activeOrder,q2Created});
    },
    removeCartItem: async function(e,cartitemid){
        e.stopPropagation();
        // Make cart item active false
        await this.strapi.axios.put('/remove-manualcartitems/'+cartitemid,{active:false});
        if(cartid){
            // Update Existing CartTotal
            await this.strapi.axios.put('/carts/update-manual-cart/'+cartid,{});
        }
        this.refreshData(true);
    },
    updateCartItem: async function(e,cartitem){
        e.preventDefault();
        let form = $('#'+e.target.id),
            reqBody= {};
        $.map(form.serializeArray(), function(n, i){
            reqBody[n['name']] = n['value'];
        });

        if(cartitem.manualPrice){
            let body={
                subtotal: document.getElementById('ManualAmount_'+cartitem.id).value,
            }
            if(cartitem.showTax){
                body.sgst= document.getElementById('sgst_'+cartitem.id).value,
                body.cgst= document.getElementById('cgst_'+cartitem.id).value
            }else{
                body.sgst= body.subtotal*0.09;
                body.cgst= body.subtotal*0.09;
            }  

            // Convert to Numbers
            Object.keys(body).map(e=>{
                if(typeof body[e]=='string') body[e]=Number(body[e]);
                body[e]=Number(body[e].toFixed(2));
            });
            body.directPrice = cartitem.manualPrice;
            reqBody={...reqBody,price:body};
        }

        let updatedcartitemdata = this.getResponseData(await this.strapi.axios.put('/cartitems/updatemanualitem/'+cartitem.id,reqBody)) || {};
        if(updatedcartitemdata && updatedcartitemdata.id) this.refreshData(true);
    },
    async init(){
        this.order = this.getResponseData(await this.strapi.axios.get('/orders/'+this.$route.params.oid)) || {};
        this.refreshData();
    },
    async refreshData(force = false){
        if(!this.refresh || force){
            if(this.order && this.order.quote && this.order.quote.cart && (!this.order.manualQuote || !this.order.manualQuote.Order)){
                this.manualcartItems = this.getResponseData(await this.strapi.axios.get('/carts/manual/'+this.order.quote.cart)) || {};
                if(this.manualcartItems.length && (this.manualcartItems.length === this.manualcartItems.filter(e=>e.price&&e.price.subtotal).length)) this.order.generateQuote=true;
            }
        }
    },
    async generateUrl({userId,cartId,quoteId,orderId=false,q2Created=false}){
        let encryptedText = this.getResponseData(await this.strapi.axios.post('/auth/encrypt',{userId,cartId,quoteId,orderId}));
        let quoteLink = encodeURIComponent(encryptedText);
        // Update Generated Quote Link to the current Order
        await this.strapi.axios.put(`/orders/${this.order.id}`,{manualQuoteLink:'https://soch3d.com/checkout/?token='+quoteLink});
        // Q2 Created Email Notification or // Q2 Updated Email Notification
        let notificationStatus = this.getResponseData(await this.strapi.axios.post('/orders/quote-notification',{orderId: this.order.id,quoteLink:quoteLink,newlyCreated : q2Created}));
        if(notificationStatus && notificationStatus.success) this.showModal = true;
    }
  },
  watch:{
    $route (to,from){
      this.init();
    }
  }
}
</script>

<style scoped>
    /* .manualCost .card-body{
        display: flex;
        flex-wrap: wrap;
    } */

</style>